export enum NodeHandleType {
  Target = 'target',
  Source = 'source',
}
